import _ from "lodash";
import get from "lodash/get";
import moment from "moment";
import defaults from "lodash/defaults";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import MenstrualCycle from "./MenstrualCycle";
import { DATE_FORMATS } from "../../../../constants";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const { DATE_YEAR_FORMAT } = DATE_FORMATS;

const MenstrualCycleController = (app) => {
  app.get("/female-cycle", async ({ res, req, locals, load }) => {
    const { query = {} } = req;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const athlete = query.athlete || get(locals, "athlete._id");

    // Load all logs (without date filtering) for prediction calculations
    await load("femaleCycleLogs", { proxyAthlete: athlete });
    await load("femaleCycleSettings", { proxyAthlete: athlete });

    // Default month: when user has settings and no logs, use first setting month so calendar shows it + 5 months
    const hasLogs = locals.femaleCycleLogs && locals.femaleCycleLogs.length > 0;
    const firstPeriod = get(
      locals,
      "femaleCycleSettings.firstRegisteredPeriod"
    );
    defaults(query, {
      month:
        !hasLogs && firstPeriod
          ? moment(String(firstPeriod), "YYYYMMDD")
              .startOf("month")
              .format(DATE_YEAR_FORMAT)
          : moment().format(DATE_YEAR_FORMAT),
    });

    const { checkin, showBack } = query;

    let comesFromCheckin = false;

    if (Boolean(checkin) && req?.original?.headers?.referer) {
      comesFromCheckin =
        req.original.headers.referer.includes("check-in-summary");
    }
    if (showBack) comesFromCheckin = true;
    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];

    res.body = (
      <MenstrualCycle
        locals={locals}
        comesFromCheckin={comesFromCheckin}
        selectedMonth={query.month}
      />
    );
  });
};

export default MenstrualCycleController;
